module.exports = __webpack_public_path__ + "img/am.svg";